import { style } from 'typestyle'
export const flex = style({ display: 'flex' })
